const locale = {
    placeholder: 'समय का चयन करें',
    rangePlaceholder: ['आरंभिक समय', 'अंत समय'],
};
export default locale;
